import React from 'react';

interface CheckProps {
  value: any;
  handleOnChange: () => void;
  disabled?: any;
  relatedCourses?: boolean;
  typeCourse: string;
}

export const CheckboxInput: React.FC<CheckProps> = (props) => {
  const { value, handleOnChange, disabled, relatedCourses, typeCourse } = props;

  let courseStatus;

  if (typeCourse === 'A') {
    courseStatus = 'Aprobado';
  } else if (typeCourse === 'D') {
    courseStatus = 'Desaprobado';
  } else if (typeCourse === 'S') {
    courseStatus = 'Suspendido';
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        fontSize: 14,
        color: '#161D1F',
        marginBottom: 16
      }}
    >
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 400
        }}
      >
        <input
          data-testid="checkbox-input"
          style={{
            visibility: 'inherit',
            accentColor: '#745EF6',
            width: 16,
            height: 16,
            marginRight: 8,
            cursor: disabled ? '' : 'pointer'
          }}
          type="checkbox"
          id="cbox1"
          value={value}
          name="checkBox"
          onChange={handleOnChange}
          disabled={
            disabled ||
            typeCourse === 'A' ||
            typeCourse === 'D' ||
            typeCourse === 'S'
          }
        />
        {relatedCourses ? (
          <ul style={{ listStyleType: 'disc', marginLeft: '20px' }}>
            <li>{value.courses[0].name}</li>
            <li>{value.courses[1].name}</li>
          </ul>
        ) : (
          <div>
            <p
              style={{
                fontSize: 12,
                color:
                  typeCourse === 'A' || typeCourse === 'D' || typeCourse === 'S'
                    ? '##BFC6DC'
                    : '#161D1F'
              }}
            >
              {value}
            </p>
            {courseStatus && (
              <p
                style={{
                  fontSize: 12,
                  marginTop: -4,
                  color: '#8090BB'
                }}
              >
                {courseStatus}
              </p>
            )}
          </div>
        )}
      </label>
    </div>
  );
};
